import { ConfirmModal } from "@components/index";

export const SubmitQuestionnaireConfirmModal = ({
  show,
  onClickCancel,
  onClickConfirm,
}: {
  show: boolean;
  onClickCancel: () => void;
  onClickConfirm: () => void;
}) => (
  <ConfirmModal
    show={show}
    confirmButtonTitle="Confirm"
    text1="Are you sure you want to submit?"
    text2="You won’t be able to edit it afterwards."
    onClickCancel={onClickCancel}
    onClickConfirm={onClickConfirm}
  />
);
